export default __webpack_public_path__ + "static/bg-04-5394b4849d82a1766be5e866c7ca0447.png";